<app-help-popup *ngIf="helpKey" [key]="helpKey">
</app-help-popup>

<div class="wrapper" (click)="continue.emit(quote)">
  <label class="header">
    <span *ngIf="mode === 'lta'">Level Term<br />Family Cover</span>
    <span *ngIf="mode === 'dta'">Decreasing Term<br />Mortgage Cover</span>
  </label>
  <div class="result">
    <div [ngSwitch]="quote.result?.financialAllocationType">
      <label class="amount" *ngSwitchDefault>
        {{quote.result?.premium | pounds}}<small>{{quote.result?.premium | appcents}}</small>
        <span class="pm">/month</span>
      </label>
      <label class="amount sumassured" *ngSwitchCase="'Premium'">
        Sum Assured: {{quote.result?.sumAssured | pounds}}
      </label>
    </div>

    <label class="block__valid">
      Quote valid until: {{quote.result.validUntil | date:'dd/MM/yyyy'}}
    </label>
  </div>

  <div class="summary__buttons">
    <ion-button [disabled]="!quote?.key">
      Select
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</div>